import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { formatearFecha, hoy } from '@/shared/lib/fecha';
import { Recuadro } from '@/shared/components/ui/Estructura';
import { useSesion } from '@/shared/auth/useSesion';
import { useEsMovil } from '@/shared/hooks/useEsMovil';
import { seccionesVisibles } from './menu';

/** Pantalla de inicio: accesos directos a lo que el rol del usuario puede usar. */
export function InicioPage() {
  const { data: sesion } = useSesion();
  const esMovil = useEsMovil();
  const secciones = useMemo(
    () => (sesion ? seccionesVisibles(sesion.permisos, esMovil) : []),
    [sesion, esMovil],
  );

  if (!sesion) return null;

  return (
    <div>
      <h1 className="text-xl font-bold text-marca-800">Hola, {sesion.usuario}</h1>
      <p className="mb-4 text-sm text-slate-500">
        {formatearFecha(hoy())}
        {sesion.rol ? ` · Rol: ${sesion.rol}` : ''}
      </p>
      {esMovil ? (
        <p className="mb-4 rounded border border-slate-300 bg-white p-3 text-sm text-slate-600">
          Consulta móvil: buscá una persona para ver su cuenta, documentos y cereal. Las cargas y
          modificaciones se realizan desde una computadora.
        </p>
      ) : null}

      {secciones.length === 0 ? (
        <p className="text-slate-600">
          Tu rol no tiene áreas habilitadas. Consultá con el administrador.
        </p>
      ) : (
        <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
          {secciones.map((seccion) => (
            <Recuadro key={seccion.id} titulo={seccion.etiqueta}>
              <ul className="space-y-1 text-sm">
                {seccion.pestanias.map((pestania) => (
                  <li key={pestania.ruta}>
                    <Link
                      to={pestania.ruta}
                      className="block py-0.5 text-marca-700 hover:underline pointer-coarse:py-1.5"
                    >
                      {pestania.etiqueta}
                    </Link>
                  </li>
                ))}
              </ul>
            </Recuadro>
          ))}
        </div>
      )}
    </div>
  );
}
